import { useRef } from "react";
const useForwardedRef = (forwardedRef) => {
    const localRef = useRef(null);
    return [
        localRef,
        (ref) => {
            localRef.current = ref;
            if (typeof forwardedRef === "function") {
                forwardedRef(ref);
            }
            else if (forwardedRef) {
                forwardedRef.current = ref;
            }
        },
    ];
};
export default useForwardedRef;
//# sourceMappingURL=useForwardedRef.js.map